import { getCustomers } from "api/graphQL_customers";
import { useEffect, useState, useContext } from "react";
import toast from "react-hot-toast";
import CustomerTable from "./components/CustomerList";
import { ClientContext } from "ClientProvider";
import { useLocation } from "react-router-dom";
import CreateCustomerModal from "./components/CreateCustomerModal";
import { getAllGatewaysSecond } from "api/graphQL_gateways";

export interface ClientRowObj {
  customer_id: string;
  client_id: string;
  first_name: string;
  last_name: string;
  middle_name: string;
  email: string;
  phone: string;
  city: string;
  address: string;
  state: string;
  country: string;
  source_client: string;
  reference_id: string;
  created_at: string;
  updated_at: string;
  total_transactions: any;
  transactionsList: any;
  paymentMethods: any;
  kyc: any;
}

export type AllGatewayObj = {
  name: string;
  id: string;
};

const Customers = () => {
  const [clients, setClients] = useState<ClientRowObj[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>();
  const { singleRoleData, setSingleRoleData } = useContext(ClientContext);
  const [page, setPage] = useState<number>(1);
  const [totalpage, setTotalPage] = useState<number>(0);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(50);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [allGateways, setAllGateways] = useState<AllGatewayObj[]>([]);
  const [searchTexts, setSearchTexts] = useState<string>("");
  const location = useLocation();
  const [allOrgDetails, setAllOrgDetails] = useState<any>();

  const [filter, setFilter] = useState({
    clients: [] , gateways: [] , dates: null
  });

  const [clearClicked, setClearClick] = useState(0);  

  const fetchClients = async () => {
    let finalSearchText = "";
    if (location.state) {
      if (location.state?.search) {
        finalSearchText = location.state.search;
        window.history.replaceState({}, document.title);
      }
    } else {
      finalSearchText = searchTexts;
    }
    const params = { page, per_page: pageSize, searchTexts: finalSearchText,filter:filter };
    if (pageSize === null || pageSize === undefined) {
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    getCustomers(params)
      .then((data: any) => {
        if (data.status === "Error") {
          setClients([]); setTotalPage(1); setTotalItems(0); setCurrentPage(1);
        } else {
          setClients(data?.[0]);
          setTotalPage(data?.[1].total_pages);
          setTotalItems(data?.[1].total_items);
          setCurrentPage(data?.[1].current_page);
        }
      })
      .catch(() => {
        setClients([]);
        setIsLoading(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const serchboxValueChange = async (searchTerm: string) => {
    const search_txt = searchTerm || "";
    if (search_txt !== searchTexts && searchTexts !== "") {
      await setSearchTexts(search_txt);
      setPage(1);
      setCurrentPage(1);
    } else {
      await setSearchTexts(search_txt);
    }
  };

  const filterData = () => {
      let finalSearchText = "";
    if (location.state) {
      if (location.state?.search) {
        finalSearchText = location.state.search;
        window.history.replaceState({}, document.title);
      }
    } else {
      finalSearchText = searchTexts;
    }
    const params = { page, per_page: pageSize, searchTexts: finalSearchText,filter:filter };
    if (pageSize === null || pageSize === undefined) {
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    getCustomers(params)
      .then((data: any) => {
        if (data.status === "Error") {
          setClients([]); setTotalPage(1); setTotalItems(0); setCurrentPage(1);
        } else {
          setClients(data?.[0]);
          setTotalPage(data?.[1].total_pages);
          setTotalItems(data?.[1].total_items);
          setCurrentPage(data?.[1].current_page);
        }
      })
      .catch(() => {
        setClients([]);
        setIsLoading(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
    };

  const onClearClick = () => setClearClick((prev) => prev + 1);

const fecthOrgData = () => {

    getAllGatewaysSecond()
      .then((data) => {
        setAllOrgDetails(
          data?.map((gateway: any) => ({
            ...gateway,
            label: gateway?.name,
            value: gateway?.id,
          }))
        );
      })
      .catch(() => {});
  };

  useEffect(() => {
      fecthOrgData();
    }, []);

  useEffect(() => {
    fetchClients();
  }, [page, pageSize, searchTexts,clearClicked]);

  useEffect(() => {
    setPageSize(50);
  }, [searchTexts]);

  return (
    <div className="cust-root">
      {/* Page header */}
      <div className="cust-page-header">
        <div className="cust-page-title-block">
          <div className="cust-page-icon">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          </div>
          <div>
            <h1 className="cust-page-heading">Customers</h1>
            <p className="cust-page-sub">
              Manage customer profiles, KYC and payment methods
            </p>
          </div>
        </div>
        <div className="cust-page-actions">
          {singleRoleData?.[0]?.customers?.value?.add_customer && (
            <CreateCustomerModal
              fetchClients={fetchClients}
              roleData={singleRoleData}
            />
          )}
        </div>
      </div>

      {/* Table */}
      <CustomerTable
        tableData={clients}
        fetchClients={fetchClients}
        isLoading={isLoading}
        roleData={singleRoleData}
        page={page}
        setPage={setPage}
        totalpage={totalpage}
        totalItems={totalItems}
        currentPage={currentPage}
        pageSize={pageSize}
        allGateways={allGateways}
        setPageSize={setPageSize}
        onValueChange={serchboxValueChange}
        allOrgDetails={allOrgDetails}
        filter={filter}
        setFilter={setFilter}
        setClearClick={onClearClick}
        filterData={filterData}
      />

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        .cust-root {
          font-family: 'Plus Jakarta Sans', sans-serif;
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          gap: 20px;
        }
        .cust-page-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 16px;
        }
        .cust-page-title-block { display: flex; align-items: center; gap: 14px; }
        .cust-page-icon {
          width: 44px; height: 44px; border-radius: 12px;
          background: linear-gradient(135deg, #f0fdf4, #dcfce7);
          border: 1.5px solid #bbf7d0;
          display: flex; align-items: center; justify-content: center;
          color: #16a34a; flex-shrink: 0;
        }
        .cust-page-heading {
          font-size: 20px; font-weight: 800; color: #0f172a;
          letter-spacing: -0.4px; margin-bottom: 2px; line-height: 22px;
        }
        .cust-page-sub { font-size: 13px; color: #94a3b8; font-weight: 500; }
        .cust-page-actions { display: flex; gap: 10px; align-items: center; flex-wrap: wrap; }

        @media (max-width: 600px) {
          .cust-root { padding: 14px; gap: 14px; }
          .cust-page-header { flex-direction: column; align-items: flex-start; }
        }
      `}</style>
    </div>
  );
};

export default Customers;